import React, { useState, useEffect } from 'react';
import { applicationService } from '../../services/api';
import './AdminPage.css';
import './AdminApplications.css';

function AdminApplications() {
  const [applications, setApplications] = useState([]);
  const [loading, setLoading] = useState(false);
  const [expandedId, setExpandedId] = useState(null);

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    try {
      setLoading(true);
      setApplications(await applicationService.getApplications());
    } catch (error) {
      alert('Error loading applications: ' + error.message);
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm('Delete this application?')) {
      try {
        await applicationService.deleteApplication(id);
        loadData();
      } catch (error) {
        alert('Error: ' + error.message);
      }
    }
  };

  const toggleExpand = (id) => {
    setExpandedId(expandedId === id ? null : id);
  };

  const formatDate = (d) => d ? new Date(d).toLocaleDateString() : '';

  return (
    <div className="admin-page">
      <div className="page-header page-headeradmin">
        <h1>Applications Management</h1>
      </div>

      {loading && !applications.length ? (
        <div className="loading">Loading...</div>
      ) : (
        <div className="table-container applications-table-wrap">
          <table className="data-table applications-table">
            <thead>
              <tr>
                <th>Student</th>
                <th>Code</th>
                <th>Email</th>
                <th>Mobile</th>
                <th>Vacancy</th>
                <th>Company</th>
                <th>Date</th>
                <th>Resume</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {applications.map((a) => (
                <React.Fragment key={a.Id}>
                  <tr onClick={() => toggleExpand(a.Id)} className="application-row">
                    <td>{a.Student?.Name}</td>
                    <td>{a.Student?.Code}</td>
                    <td>{a.Student?.Email}</td>
                    <td>{a.Student?.MobileNo}</td>
                    <td>{a.Vacancy?.Title}</td>
                    <td>{a.Vacancy?.Company?.Name}</td>
                    <td>{formatDate(a.Date)}</td>
                    <td>{a.Resume ? a.Resume.split(/[/\\]/).pop() : '-'}</td>
                    <td onClick={(e) => e.stopPropagation()}>
                      <button className="btn-delete" onClick={() => handleDelete(a.Id)}>Delete</button>
                    </td>
                  </tr>
                  {expandedId === a.Id && (
                    <tr className="application-details-row">
                      <td colSpan="9">
                        <div className="application-details">
                          {a.Description && (
                            <div><strong>Description:</strong> {a.Description}</div>
                          )}
                          {a.Answer1 && (
                            <div><strong>Answer 1:</strong> {a.Answer1}</div>
                          )}
                          {a.Answer2 && (
                            <div><strong>Answer 2:</strong> {a.Answer2}</div>
                          )}
                          {a.Answer3 && (
                            <div><strong>Answer 3:</strong> {a.Answer3}</div>
                          )}
                        </div>
                      </td>
                    </tr>
                  )}
                </React.Fragment>
              ))}
            </tbody>
          </table>
          {!loading && applications.length === 0 && (
            <p style={{ padding: '2rem', textAlign: 'center', color: '#666' }}>No applications found.</p>
          )}
        </div>
      )}
    </div>
  );
}

export default AdminApplications;
